import { RefererTyCStl } from "./refererTyCStl";

export const KonfioTyC = () => {
   return <RefererTyCStl>
      <h3> TÉRMINOS Y CONDICIONES CANAL DIGITAL SÍ VALE KONFÍO </h3>
      <section>
         <h4>Responsable:</h4>
         <p>
            <bold>SÍ VALE MÉXICO, S.A. DE C.V. </bold> , con domicilio en Av. Paseo de la Reforma #284 Piso 23, Col. Juárez, Alcaldía Cuauhtémoc, Ciudad de México, C.P. 06600 con número telefónico 51 41 60 00 y/o correo electrónico atencionaclientes@sivale.com.mx (en adelante “UP SÍ VALE”).
         </p>

         <h4>Nombre promoción:</h4>
         <p>
            CANAL DIGITAL UP SÍ VALE KONFÍO.
         </p>

         <h4>Territorio:</h4>
         <p>
            República Mexicana.
         </p>

         <h4>Vigencia de la promoción:</h4>
         <p>
            Del 18 de abril al 31 de julio del 2022.
         </p>

         <h4>Plazo para hacer valida la promoción:</h4>
         <p>
            60 (sesenta días naturales) después de realizar la cotización de los productos UP SÍ VALE (Despensa y/o Combustible y/o Crédito de Incentivos para empleados) a través de la URL <a href="https://sivale.mx/compra-en-linea?referer=Konfio"> <bold> sivale.mx/compra-en-linea?referer=Konfio. </bold> </a>
         </p>

         <h4>Productos Participantes</h4>
         <p>
            Despensa, Combustible y Crédito de Incentivos para empleados.
         </p>

         <h4>Participantes:</h4>
         <p>
            Promoción exclusiva para todos los clientes de KONFÍO que <bold>NO SON</bold> clientes de UP SÍ VALE que coticen y contraten los productos de UP SÍ VALE (Despensa y/o Combustible y/o Crédito de Incentivos para empleados) a través de la URL <a href="https://sivale.mx/compra-en-linea?referer=Konfio"> <bold> sivale.mx/compra-en-linea?referer=Konfio. </bold> </a>
         </p>

         <h4>Promoción</h4>
         <p>
            Por ser cliente KONFÍO obtén un descuento especial al contratar los productos de UP SÍ VALE (Despensa y/o Combustible y/o Crédito de Incentivos para empleados).
            <br />
            100% (cien por ciento) de descuento en el costo de la Inscripción y 50% (cincuenta por ciento) de descuento en el costo de tarjetas titulares (únicamente para el primer pedido de tarjetas y primer cobro de inscripción).
         </p>

         <h4>Condiciones </h4>
         <ul>
            <li> Solo aplica en contrataciones a través de la URL <a href="https://sivale.mx/compra-en-linea?referer=Konfio"> <bold> sivale.mx/compra-en-linea?referer=Konfio. </bold> </a> </li>
            <li> Dirigido a clientes KONFÍO que no son clientes UP SÍ VALE. </li>
            <li> La promoción es válida solo para el primer pedido de tarjetas y primer cobro de inscripción). </li>
         </ul>

         <h4>Restricciones: </h4>
         <ul>
            <li> No aplica con otras promociones.</li>
            <li> No aplica para los clientes actuales de UP SÍ VALE, solo para clientes nuevos. </li>
            <li> No aplica en contrataciones de Productos a través de otros canales de venta de UP SÍ VALE. </li>
         </ul>

         <p> En caso de dudas, quejas o reclamaciones por favor comunícate al número telefónico 51 41 60 00 y/o correo electrónico atencionaclientes@sivale.com.mx. </p>

         <p>
            <bold>
               UP SÍ VALE se reserva el derecho de actualizar los términos y condiciones de la presente promoción en cualquier momento.
            </bold>
         </p>

      </section>
   </RefererTyCStl>;
};


